import MultiTabEmptyPage from './MultiTabEmptyPage';

export default MultiTabEmptyPage;